// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Logout_wrapper__GqIeV","button":"Logout_button__3H3SH","Icon":"Logout_Icon__1lyTl"};